import { ApiJobId, ApiOrgId } from 'api/types/ApiTypedId';
import { FetchEndpoint } from 'utils/endpoint/FetchEndpoint';

import { OrgDashboardApiJob } from './types/OrgDashboardApiJob';

type ApiResponse = {
  job: OrgDashboardApiJob;
};

function mapResponse(response: ApiResponse): OrgDashboardApiJob {
  return response.job;
}

const endpoint = new FetchEndpoint({
  urlFactory: (orgId: ApiOrgId, jobId: ApiJobId) =>
    `/data/orgdashboard/${orgId}/jobs/${jobId}`,
  mapResponse,
});

// Exports

export const orgDashboardApiFetchJob = endpoint.createFetchFn();

export const useOrgDashboardApiFetchJob = endpoint.createUseFetchHook();
